import { GateInFormDialog } from '@tom-ui/planning/pages/GateControl/Components/GateInDialog'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useGateInBridge } from './useGateInBridge'

export const GateInFormDialogWrapper: React.FC = observer(() => {
  const bridge = useGateInBridge()
  return <GateInFormDialog {...bridge} />
})
